import { OPEN_EMAIL_SIDEBAR } from 'EmailEditorUI/redux/actions/actionTypes';
import { UPDATE_SIDEBAR_TAB, UPDATE_DEFAULT_TAB, SELECT_PATTERN_EDIT, SET_MODULES_SEARCH_TERM, CHANGE_SECTION_LAYOUT, UPDATE_SECTION_STYLE, CLOSE_EMAIL_SIDEBAR, ADD_PANEL_TAB_CHANGED, UPDATE_EDIT_SIDEBAR_ACTIVE_TAB, UPDATE_SECTION_BREAKPOINT_STYLE } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
// @ts-expect-error not typed
import { closePopOutEditor } from 'ContentEditorUI/redux/actions/appActions';
import { getHasOpenPopOutEditor } from 'ContentEditorUI/redux/selectors/modalSelectors';
export function updateSidebarTab(tabNames) {
  return (dispatch, getState) => {
    if (getHasOpenPopOutEditor(getState())) {
      dispatch(closePopOutEditor());
    }
    dispatch(Object.assign({
      type: UPDATE_SIDEBAR_TAB
    }, tabNames));
  };
}
export function updateSidebarDefaultTab(tabNames) {
  return Object.assign({
    type: UPDATE_DEFAULT_TAB
  }, tabNames);
}
export function collapseSidebar() {
  return {
    type: CLOSE_EMAIL_SIDEBAR
  };
}
export function expandSidebar() {
  return {
    type: OPEN_EMAIL_SIDEBAR
  };
}
export function addPanelTabChanged(tabName) {
  return {
    type: ADD_PANEL_TAB_CHANGED,
    tabName
  };
}

// drag drop sidebar actions
export function selectPatternEdit({
  breakpointName,
  isEditingForAllDevices
}) {
  return {
    type: SELECT_PATTERN_EDIT,
    payload: {
      breakpointName,
      isEditingForAllDevices
    }
  };
}
export function changeSectionLayout(index, newCols) {
  return {
    type: CHANGE_SECTION_LAYOUT,
    index,
    newCols
  };
}
export function updateSectionStyle(index, property, value) {
  return {
    type: UPDATE_SECTION_STYLE,
    index,
    property,
    value
  };
}
export function updateSectionBreakpointStyle({
  index,
  newStyles,
  breakpointName,
  isEditingForAllDevices = true
}) {
  return {
    type: UPDATE_SECTION_BREAKPOINT_STYLE,
    index,
    breakpointName,
    isEditingForAllDevices,
    newStyles
  };
}
export function updateEditSidebarActiveTab(tab) {
  return {
    type: UPDATE_EDIT_SIDEBAR_ACTIVE_TAB,
    payload: tab
  };
}
export function setModulesSearchTerm(modulesSearchTerm) {
  return {
    type: SET_MODULES_SEARCH_TERM,
    modulesSearchTerm
  };
}